import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageSEO from "@/components/feature/PageSEO";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import AboutTrust from "./components/AboutTrust";
import ArticlePreview from "./components/ArticlePreview";
import Testimonial from "./components/Testimonial";
import CTASection from "./components/CTASection";

const siteUrl = typeof import.meta !== "undefined" && import.meta.env ? (import.meta.env.VITE_SITE_URL as string) || "https://acbuyspreadsheet.casa" : "https://acbuyspreadsheet.casa";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "ACBuy Spreadsheet",
  "url": siteUrl,
  "description": "The ultimate acbuyspreadsheet resource — discover verified product categories, updated sourcing lists, and everything you need to navigate the ACBuy spreadsheet ecosystem efficiently.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${siteUrl}/?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export default function Home() {
  return (
    <>
      <PageSEO
        title="ACBuySpreadsheet Guide 2026 — Ultimate Product Spreadsheet Lists &amp; Categories"
        description="Discover the latest acbuyspreadsheet guide with verified product lists, category comparisons, and sourcing insights. Explore Shoes, Hoodies, T-Shirts, Jackets, and more. Visit KAS platform for updated spreadsheet data."
        path="/"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <AboutTrust />
        <ArticlePreview />
        <Testimonial />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}